import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserSchema, User } from '../types/UserSchema'
import { initAuthData } from '../services'
import { clearAuthTokens } from '../../../../shared/lib/helpers/authStorage'

const initialState: UserSchema = {
    isAuth: false,
    _inited: false
}

export const UserSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        setAuth: (state, action: PayloadAction<boolean>) => {
            state.isAuth = action.payload
        },
        setUser: (state, action: PayloadAction<User>) => {
            state.user_session_data = action.payload
        },
        initAuth: (state) => {
            state._inited = true
        },
        logOut: (state) => {
            state.isAuth = false
            state.user_session_data = undefined
            clearAuthTokens()
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(initAuthData.pending, (state) => {
                state.error = undefined
                state.isLoading = true
            })
            .addCase(initAuthData.fulfilled, (state) => {
                state.isLoading = false
            })
            .addCase(initAuthData.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    }
})

export const { actions: UserActions } = UserSlice
export const { reducer: UserReducer } = UserSlice
